import type { IconData } from '@stacksjs/iconify-core'

export const cd4x3: IconData = {
  "body": "<path fill=\"#007fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#f7d618\" d=\"M28.8 96H96l20.8-67.2L137.6 96h67.2l-54.4 41.6l20.8 67.2l-54.4-41.6l-54.4 41.6l20.8-67.2zM600 0L0 360v120h40l600-360V0z\"/><path fill=\"#ce1021\" d=\"M640 0L0 384v96L640 96z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cd4x3
